import * as Yup from 'yup'

const PresiteSupervisor = Yup.object().shape({
    id: Yup.number().nullable(),
})

export const PresiteSupervisorCollection = Yup.object().shape({
    guniteSupervisors: Yup.array().of(PresiteSupervisor),
    pebbleSupervisors: Yup.array().of(PresiteSupervisor)
})